import { createState } from "@/global/store/zustand_store";
import { NotificationModal } from "@/shared/common/InfoPopup/NotificationModal";
import { Box, Typography } from "@mui/material";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import React from "react";
import { throttleTime } from "@/global/utils/utils";

interface TModalState {
  isOpen: boolean;
  onConfirm?: () => void;
}

let resolve: any = null;
const useModalState = createState({
  isOpen: false,
  onConfirm: () => {},
});

export const useCancelCartWarningModal = () => {
  const modalState = useModalState();

  const execute = async (state: Partial<TModalState>) => {
    return new Promise((res) => {
      resolve = res;
      modalState.set({ isOpen: true, ...state });
    }) as Promise<{ isConfirmed: boolean }>;
  };

  const onClose = () => {
    modalState.set({ isOpen: false });
    throttleTime(200, () => {
      modalState.reset();
    });
  };

  return {
    ...modalState,
    execute,
    onClose,
  };
};

export function CancelCartWarningModal() {
  const { sm: smDown } = useCssMediaQuery("down");
  const modalState = useCancelCartWarningModal();

  const handleCloseOrConfirm = () => {
    resolve?.();
    modalState.onConfirm();
    modalState.reset();
  };

  return (
    <NotificationModal
      isOpen={modalState.isOpen}
      hideTitleIcon
      hideSecondaryButton
      onClose={() => handleCloseOrConfirm()}
      onClickPrimaryButton={() => handleCloseOrConfirm()}
      title="Timeout!"
      primaryButtonText="Close"
      renderBody={() => {
        return (
          <Box p={smDown ? 2 : 3}>
            <Box>
              <Typography variant="body1">
                We are unable to process your request at this time. To avoid
                further issues with your transaction, we are canceling it and
                directing you to try again. We apologize for the inconvenience.
              </Typography>
            </Box>
          </Box>
        );
      }}
    />
  );
}
